module.exports = __webpack_public_path__ + "img/3000.18db036d.jpg";